import {makeStyles} from 'tss-react/mui';
import {agentDeveloperUtils} from 'wobi-web-common';

export default makeStyles()((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    position: 'relative',
    width: '90%',
    maxWidth: 500,
    backgroundColor: '#ffffff',
    borderRadius: 10,
    padding: 32,
    paddingTop: 48,
    textAlign: 'center',
    outline: 'none',
    maxHeight: '90vh',
    overflowY: 'auto',
    direction: 'rtl',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 20,
      paddingTop: 40,
    },
  },
  closeButton: {
    position: 'absolute',
    top: 12,
    left: 'auto',
    right: 12,
    width: 28,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: '50%',
    backgroundColor: '#f0f0f0',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  closeX: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#666',
    lineHeight: 1,
  },
  logoWrapper: {
    marginBottom: 20,
  },
  logo: {
    maxWidth: 150,
    maxHeight: 84,
    objectFit: 'contain',
  },
  title: {
    color: agentDeveloperUtils.getPrimaryColor(440),
    fontSize: 22,
    fontWeight: 'bold',
    fontFamily: theme.typography.fontFamily,
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  text: {
    color: '#333',
    fontSize: 14,
    fontFamily: theme.typography.fontFamily,
    lineHeight: 1.6,
    marginBottom: 24,
    textAlign: 'justify',
    direction: 'rtl',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  confirmButton: {
    minWidth: 150,
    height: 44,
    borderRadius: 22,
    fontWeight: 'bold',
    fontSize: 16,
    fontFamily: theme.typography.fontFamily,
    backgroundColor: agentDeveloperUtils.getPrimaryColor(440),
    '&:hover': {
      backgroundColor: agentDeveloperUtils.getPrimaryColor(600),
    },
  },
}));
